import { Icon, type IconName } from "@blueprintjs/core";

interface EmptyStateCardProps {
  icon?: IconName;
  title: string;
  description: string;
  className?: string;
  iconClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
}

export const EmptyStateCard = ({
  icon = "satellite",
  title,
  description,
  className = "",
  iconClassName = "",
  titleClassName = "",
  descriptionClassName = "",
}: EmptyStateCardProps) => (
  <div className={`flex h-full min-h-[240px] items-center justify-center p-6 ${className}`.trim()}>
    <div className="flex max-w-sm flex-col items-center rounded-lg border border-dashed border-slate-200 bg-white px-6 py-8 text-center shadow-sm">
      <span
        className={`mb-3 flex h-11 w-11 items-center justify-center rounded-lg bg-slate-100 text-slate-500 ${iconClassName}`.trim()}
      >
        <Icon icon={icon} title={false} />
      </span>
      <h3 className={`text-sm font-bold text-slate-950 ${titleClassName}`.trim()}>
        {title}
      </h3>
      <p className={`mt-1 text-sm font-medium text-slate-500 ${descriptionClassName}`.trim()}>
        {description}
      </p>
    </div>
  </div>
);
